// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/user/layouts/PageLayout/PageLayout.scss
// module id = 819
// module chunks = 0